module.exports = __webpack_public_path__ + "media/KikiDavid.8013abd0.mp3";